<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="auto" md="12" class="p-0 pr-3">
						<h2>My Accidents / Incidents / Complaints / Feedback</h2>
					</b-col>
					<b-col align-self="center" lg="" md="12" class="p-0">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search" @input="$emit('set-search')">
							</div>
							<div class="mh-time-status">
								<b-select class="btn-select" v-model="typeFilter" :options="incidentTypes" text-field="name" value-field="value" />
							</div>
							<div class="mh-add-entry"><button class="btn btn-default" @click="onNewClick">New</button></div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div v-show="!showForm" class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col cols="12" class="p-0">
							<div class="table-reponsive mh-entries-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												sortingMode="single"
												tableClass="table table-curved dataTable"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>

			<b-card no-body v-show="showForm" class="mh-card mh-card-page">
				<b-card-header class="mh-bg-primary d-flex align-items-center">
					<h3 class="card-title">{{isAdding ? 'Add' : 'Update'}} Accident / Incident</h3>
					<b-col cols="auto" class="ml-auto p-0">
						<button type="button" class="btn btn-link mh-btn-icon" @click="closeForm"><i class="mh-icon-close"></i></button>
					</b-col>
				</b-card-header>
				<b-card-body class="mh-off-middle pl-0 pr-0">
					<fieldset :disabled="isFormDisabled">
						<b-row class="m-0">
							<b-col lg="6" md="12">
								<label class="mh-label required">Date</label>
								<div class="mh-datepicker">
									<datepicker v-model="date" />
									<i class="mh-icon-calendar"></i>
								</div>
							</b-col>
							<b-col lg="6" md="12">
								<label class="mh-label required">Time</label>
								<div class="mh-timepicker">
									<TimeInput v-model="time" />
									<i class="mh-icon-watch"></i>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col v-if="isEmployee" lg="12" md="12">
								<label class="mh-label required">Customer/Participant</label>
								<div class="field-with-icon">
									<vue-typeahead-bootstrap :data="customers"
															 :serializer="s => s.name"
															 @hit="customerId = $event.id"
															 @keyup="($event) => { $refs.customerId.inputValue != '' ? '' : customerId = null }"
															 autocomplete="off"
															 :showOnFocus="true"
															 :minMatchingChars="1"
															 ref="customerId"></vue-typeahead-bootstrap>
									<i class="mh-icon-search"></i>
								</div>
							</b-col>
							<b-col lg="4" md="12">
								<label class="mh-label required">Type</label>
								<b-select v-model="type" :options="types" text-field="name" value-field="value" />
							</b-col>
							<b-col lg="4" md="12">
								<label class="mh-label required">Severity</label>
								<b-select v-model="severity" :options="severities" text-field="name" value-field="value" />
							</b-col>
							<b-col lg="4" md="12">
								<label class="mh-label required">Status</label>
								<b-select v-model="status" :options="statuses" text-field="name" value-field="value" />
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label required">Description</label>
									<textarea v-model="description"></textarea>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Events Before (to trigger event)</label>
									<textarea v-model="eventsBefore"></textarea>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Events During (to manage event)</label>
									<textarea v-model="eventsDuring"></textarea>
								</div>
							</b-col>
						</b-row>
						<div class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Events After (outcome)</label>
									<textarea v-model="eventsAfter"></textarea>
								</div>
							</b-col>
						</div>
						<b-row class="m-0">
							<b-col lg="4" md="12">
								<div class="form-group">
									<label class="mh-label required">Reported By</label>
									<input type="text" v-model="reportedBy" />
								</div>
							</b-col>
							<b-col lg="4" md="12">
								<div class="form-group">
									<label class="mh-label">Reporter Phone</label>
									<input type="text" v-model="reporterPhone" />
								</div>
							</b-col>
							<b-col lg="4" md="12">
								<div class="form-group">
									<label class="mh-label">Witnesses</label>
									<input type="text" v-model="witnesses" />
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Location</label>
									<input type="text" v-model="location" />
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">People Notified</label>
									<br />
									<input type="checkbox" id="notifiedManagement" v-model="notifiedManagement" /> <label for="notifiedManagement">Notified Management</label>
									<br />
									<input type="checkbox" id="notifiedStaff" v-model="notifiedStaff" /> <label for="notifiedStaff">Notified Staff</label>
									<br />
									<input type="checkbox" id="notifiedGuardian" v-model="notifiedGuardian" /> <label for="notifiedGuardian">Notified Guardian</label>
									<br />
									<input type="checkbox" id="notifiedPolice" v-model="notifiedPolice" /> <label for="notifiedPolice">Notified Police</label>
									<br />
									<input type="checkbox" id="notifiedInsurance" v-model="notifiedInsurance" /> <label for="notifiedInsurance">Notified Insurance</label>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Medical Care</label>
									<br />
									<input type="checkbox" id="examinedByDoctor" v-model="examinedByDoctor" /> <label for="examinedByDoctor">Examined By Doctor</label>
									<br />
									<input type="checkbox" id="hospitalised" v-model="hospitalised" /> <label for="hospitalised">Hospitalised?</label>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Action Taken</label>
									<textarea class="form-control" v-model="actionTaken"></textarea>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<input type="checkbox" id="furtherActionRequired" v-model="furtherActionRequired" /> <label for="furtherActionRequired">Further Action Required</label>
								</div>
							</b-col>
						</b-row>
						<b-row v-if="furtherActionRequired" class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Further Action Date</label>
									<div class="mh-datepicker">
										<datepicker v-model="furtherActionDate" />
										<i class="mh-icon-calendar"></i>
									</div>
								</div>
							</b-col>
							<b-col cols="12">
								<div class="form-group">
									<label class="mh-label">Further Actions</label>
									<textarea class="form-control" v-model="furtherActions"></textarea>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<div class="form-group">
									<h5>Attachments</h5>
								</div>
							</b-col>
							<b-col v-if="id !== 0" cols="12">
								<Documents :path="`incident/${id}/`"
										   :hideBreadcrumbs="true"
										   @input="uploadDocuments"
										   @deleted="deletedDocuments"
										   :key="reloadDocuments"
										   :showAll="true" />
							</b-col>
							<b-col v-else cols="12">
								<div class="form-group">
									<label class="mh-label">Save record first</label>
								</div>
							</b-col>
						</b-row>
					</fieldset>
					<b-row class="m-0 mh-action-nav">
						<b-col cols="6">
							<button class="btn btn-default btn-grey" @click="closeForm">Close</button>
						</b-col>
						<b-col cols="6">
							<button class="btn btn-default" @click="saveRecord" :disabled="isFormDisabled">Save</button>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>

		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import SortingIcon from "./partials/SortingIcon"
	import HtmlColumn from "./partials/HtmlColumn"
	import TableRowActions from "./partials/TableRowActions"
	import TimeInput from "./partials/controls/TimeInput"
	import Documents from "./partials/Documents"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'AccidentsIncidentsContent',
		components: {
			ContentTitle,
			SortingIcon,
			HtmlColumn,
			TableRowActions,
			TimeInput,
			Documents
		},
		data: function () {
			return {
				search: "",
				typeFilter: 0,
				editing: false,
				adding: false,
				selectedRecord: {},
				id: 0,
				date: new Date(),
				time: "",
				customerId: null,
				type: null,
				severity: null,
				status: null,
				description: null,
				eventsBefore: null,
				eventsDuring: null,
				eventsAfter: null,
				reportedBy: null,
				reporterPhone: null,
				witnesses: null,
				location: null,
				notifiedManagement: false,
				notifiedStaff: false,
				notifiedGuardian: false,
				notifiedPolice: false,
				notifiedInsurance: false,
				examinedByDoctor: false,
				hospitalised: false,
				actionTaken: null,
				furtherActionRequired: false,
				furtherActionDate: null,
				furtherActions: null,
				reloadDocuments: false
			}
		},
		mounted: function () {
			this.$store.dispatch("Incidents/getIncidents")

			bus.$off('editDetailsTableRowAction')
			bus.$on('editDetailsTableRowAction', obj => { this.editRow(obj) })
		},
		watch: {
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			incidents: function () {
				return this.$store.state.Incidents.incidents
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			types: function () {
				return this.$store.state.Incidents.types
			},
			severities: function () {
				return this.$store.state.Incidents.severities
			},
			statuses: function () {
				return this.$store.state.Incidents.statuses
			},
			incidentTypes: function () {
				var types = this.$store.state.Incidents.types.slice()

				types.unshift({ name: "", value: 0 })

				return types
			},
			records: function () {
				var icons = [
					{
						class: "mh-icon-edit",
						title: "Edit",
						emit: "editDetailsTableRowAction",
						show: "canEdit"
					}
				]

				return this.incidents
					.slice()
					.map(x => {
						return {
							id: x.id,
							type: x.type,
							name: x.name,
							date: moment(x.date, "DD/MM/YYYY hh:mm:ss A").format("DD MMM YYYY hh:mm a"),
							status: x.statusname,
							description: x.description,
							icons: icons
						}
					})
					.filter(x => {
						return (this.typeFilter == 0 || this.typeFilter == x.type)
							&& ((x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.date + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.description + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1)
					})
			},
			columns: function () {
				var columns = [
					{ key: "name", title: "Name", searchable: true, sortable: true },
					{ key: "date", title: "Date", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:fit-content;", sortingFunction: function (a, b) { return moment(b.date, "DD MMM YYYY hh:mm a").toDate() - moment(a.date, "DD MMM YYYY hh:mm a").toDate(); } },
					{ key: "status", title: "Status", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:fit-content;" },
					{ key: "description", title: "Description", searchable: true, sortable: true },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			isAdding: function () {
				return this.adding
			},
			showForm: function () {
				return this.editing || this.adding
			},
			isFormDisabled: function () {
				return this.selectedRecord != null && this.selectedRecord.locked == "1"
			},
			isDateValid: function () {
				if (this.date == null) {
					this.$store.commit("Toasts/showError", { title: "Date", content: "Date is required" })

					return false
				}

				return true
			},
			isTimeValid: function () {
				if (this.time == "") {
					this.$store.commit("Toasts/showError", { title: "Time", content: "Time is required" })

					return false
				}

				return true
			},
			isCustomerIdValid: function () {
				if (this.customerId == null) {
					this.$store.commit("Toasts/showError", { title: "Customer", content: "Customer is required" })

					return false
				}

				return true
			},
			isTypeValid: function () {
				if (this.type == null) {
					this.$store.commit("Toasts/showError", { title: "Type", content: "Type is required" })

					return false
				}

				return true
			},
			isSeverityValid: function () {
				if (this.severity == null) {
					this.$store.commit("Toasts/showError", { title: "Severity", content: "Severity is required" })

					return false
				}

				return true
			},
			isStatusValid: function () {
				if (this.status == null) {
					this.$store.commit("Toasts/showError", { title: "Status", content: "Status is required" })

					return false
				}

				return true
			},
			isDescriptionValid: function () {
				if (this.description == null || this.description == null) {
					this.$store.commit("Toasts/showError", { title: "Description", content: "Description is required" })

					return false
				}

				return true
			},
			isEventsBeforeValid: function () {
				return true
			},
			isEventsDuringValid: function () {
				return true
			},
			isEventsAfterValid: function () {
				return true
			},
			isReportedByValid: function () {
				if (this.reportedBy == null || this.reportedBy == "") {
					this.$store.commit("Toasts/showError", { title: "Reported By", content: "Reported By is required" })

					return false
				}

				return true
			},
			isReporterPhoneValid: function () {
				return true
			},
			isWitnessesValid: function () {
				return true
			},
			isLocationValid: function () {
				return true
			},
			isNotifiedManagementValid: function () {
				if (this.notifiedManagement == null) {
					this.$store.commit("Toasts/showError", { title: "Notified Management", content: "Notified Management is required" })

					return false
				}

				return true
			},
			isNotifiedStaffValid: function () {
				if (this.notifiedStaff == null) {
					this.$store.commit("Toasts/showError", { title: "Notified Staff", content: "Notified Staff is required" })

					return false
				}

				return true
			},
			isNotifiedGuardianValid: function () {
				if (this.notifiedGuardian == null) {
					this.$store.commit("Toasts/showError", { title: "Notified Guardian", content: "Notified Guardian is required" })

					return false
				}

				return true
			},
			isNotifiedPoliceValid: function () {
				if (this.notifiedPolice == null) {
					this.$store.commit("Toasts/showError", { title: "Notified Police", content: "Notified Police is required" })

					return false
				}

				return true
			},
			isNotifiedInsuranceValid: function () {
				if (this.notifiedInsurance == null) {
					this.$store.commit("Toasts/showError", { title: "Notified Insurance", content: "Notified Insurance is required" })

					return false
				}

				return true
			},
			isExaminedByDoctorValid: function () {
				if (this.examinedByDoctor == null) {
					this.$store.commit("Toasts/showError", { title: "Examined By Doctor", content: "Examined By Doctor is required" })

					return false
				}

				return true
			},
			isHospitalisedValid: function () {
				if (this.hospitalised == null) {
					this.$store.commit("Toasts/showError", { title: "Hospitalised", content: "Hospitalised is required" })

					return false
				}

				return true
			},
			isActionTakenValid: function () {
				return true
			},
			isFurtherActionRequiredValid: function () {
				return true
			},
			isFurtherActionDateValid: function () {
				if (this.furtherActionRequired && (this.furtherActionDate == null || this.furtherActionDate == "")) {
					this.$store.commit("Toasts/showError", { title: "Further Action Date", content: "Further Action Date is required" })

					return false
				}

				return true
			},
			isFurtherActionsValid: function () {
				if (this.furtherActionRequired && (this.furtherActions == null || this.furtherActions == "")) {
					this.$store.commit("Toasts/showError", { title: "Further Actions", content: "Further Actions is required" })

					return false
				}

				return true
			}
		},
		methods: {
			onNewClick: function () {
				this.selectedRecord = null
				this.adding = true

				this.setFormData()
			},
			editRow: function (obj) {
				this.editing = true
				this.selectedRecord = this.incidents.filter(x => x.id == obj.id)[0]

				this.setFormData()
			},
			closeForm: function () {
				this.editing = false
				this.adding = false
			},
			setFormData: function () {
				this.reloadDocuments = !this.reloadDocuments

				if (this.selectedRecord != null) {
					this.id = this.selectedRecord.id

					var date = moment(this.selectedRecord.date, "DD/MM/YYYY hh:mm:ss A")

					this.date = date.toDate()
					this.time = date.format("HH:mm")

					if (this.isEmployee) {
						var client = this.customers.filter(x => x.id == this.selectedRecord.clientid)[0]

						if (client != null) {
							this.customerId = client.id
							this.$refs.customerId.inputValue = client.name;
						}
					}
					else {
						this.customerId = this.profile.userid
					}

					this.type = this.selectedRecord.type
					this.severity = this.selectedRecord.severity
					this.status = this.selectedRecord.status
					this.description = this.selectedRecord.description
					this.eventsBefore = this.selectedRecord.whathappenedbefore
					this.eventsDuring = this.selectedRecord.whathappenedduring
					this.eventsAfter = this.selectedRecord.whathappenedafter
					this.reportedBy = this.selectedRecord.reportfiledby
					this.reporterPhone = this.selectedRecord.reportfiledphone
					this.witnesses = this.selectedRecord.witnesses
					this.location = this.selectedRecord.location
					this.notifiedManagement = this.selectedRecord.notifiedmanagement == 1
					this.notifiedStaff = this.selectedRecord.notifiedstaff == 1
					this.notifiedGuardian = this.selectedRecord.notifiedguardian == 1
					this.notifiedPolice = this.selectedRecord.notifiedpolice == 1
					this.notifiedInsurance = this.selectedRecord.notifiedinsurance == 1
					this.examinedByDoctor = this.selectedRecord.examinedbydoctor == 1
					this.hospitalised = this.selectedRecord.hospitalised == 1
					this.actionTaken = this.selectedRecord.actiontaken
					this.furtherActionRequired = this.selectedRecord.furtheractionrequired == 1

					if (this.selectedRecord.furtheractiondate != "")
						this.furtherActionDate = moment(this.selectedRecord.furtheractiondate, "DD/MM/YYYY hh:mm:ss A").toDate()

					this.furtherActions = this.selectedRecord.furtheraction
				}
				else {
					this.id = 0
					this.date = new Date()
					this.time = ""

					if (!this.isEmployee) {
						this.customerId = this.profile.userid
					}
					else {
						this.customerId = null
						this.$refs.customerId.inputValue = "";
					}

					this.type = null
					this.severity = null
					this.status = null
					this.description = null
					this.eventsBefore = null
					this.eventsDuring = null
					this.eventsAfter = null
					this.reportedBy = null
					this.reporterPhone = null
					this.witnesses = null
					this.location = null
					this.notifiedManagement = false
					this.notifiedStaff = false
					this.notifiedGuardian = false
					this.notifiedPolice = false
					this.notifiedInsurance = false
					this.examinedByDoctor = false
					this.hospitalised = false
					this.actionTaken = null
					this.furtherActionRequired = false
					this.furtherActionDate = null
					this.furtherActions = null
				}
			},
			isFormValid: function () {
				return this.isDateValid
					&& this.isTimeValid
					&& this.isCustomerIdValid
					&& this.isTypeValid
					&& this.isSeverityValid
					&& this.isDescriptionValid
					&& this.isEventsBeforeValid
					&& this.isEventsDuringValid
					&& this.isEventsAfterValid
					&& this.isReportedByValid
					&& this.isReporterPhoneValid
					&& this.isWitnessesValid
					&& this.isLocationValid
					&& this.isNotifiedManagementValid
					&& this.isNotifiedStaffValid
					&& this.isNotifiedGuardianValid
					&& this.isNotifiedPoliceValid
					&& this.isNotifiedInsuranceValid
					&& this.isExaminedByDoctorValid
					&& this.isHospitalisedValid
					&& this.isActionTakenValid
					&& this.isFurtherActionRequiredValid
					&& this.isFurtherActionDateValid
					&& this.isFurtherActionsValid
			},
			saveRecord: function () {
				if (!this.isFormValid()) {
					return
				}

				var date = moment(this.date).format("YYYY-MM-DD")
				var dateAndTime = `${date} ${this.time}:00`

				var parameters = {
					userId: this.profile.accounttype == 2 ? this.profile.userid : 0,
					id: this.id,
					name: `${(this.profile.accounttype == 2 ? this.$refs.customerId.inputValue : this.profile.fullname)} ${date}`,
					type: this.type,
					severity: this.severity,
					severityname: this.severities.filter(x => x.value == this.severity)[0].name,
					status: this.status,
					description: this.description,
					whathappenedbefore: this.eventsBefore,
					whathappenedduring: this.eventsDuring,
					whathappenedafter: this.eventsAfter,
					date: dateAndTime,
					clientid: this.customerId,
					notifiedmanagement: this.notifiedManagement,
					notifiedstaff: this.notifiedStaff,
					notifiedguardian: this.notifiedGuardian,
					notifiedpolice: this.notifiedPolice,
					notifiedinsurance: this.notifiedInsurance,
					location: this.location,
					witnesses: this.witnesses,
					actiontaken: this.actiontaken,
					actiondate: dateAndTime,
					furtheractionrequired: this.furtherActionRequired,
					furtheractiondate: this.furtherActionRequired ? moment(this.furtherActionDate).format("YYYY-MM-DD") : null,
					furtheraction: this.furtherActions,
					examinedbydoctor: this.examinedByDoctor,
					doctorid: 1,
					doctorreport: 0,
					hospitalised: this.hospitalised,
					hospitaltreatment: "",
					reportfiledby: this.reportedBy,
					reportfiledphone: this.reporterPhone
				}

				var $this = this

				this.$store.dispatch("Incidents/save", parameters).then(function (id) {
					$this.id = id
					$this.$store.dispatch("Incidents/getIncidents")
				})
			},
			uploadDocuments: function (files) {
				this.$store.dispatch(
					"Documents/uploadFiles",
					files
						.map(x => {
							return {
								key: `incident/${this.id}`,
								file: x
							}
						})
				)
				.then(() => {
					this.reloadDocuments = !this.reloadDocuments
				})
			},
			deletedDocuments: function () {
				this.reloadDocuments = !this.reloadDocuments
			}
		}
	};
</script>

<style scoped>
</style>